/**
 * Email Verification API Service
 * API calls for email verification functionality
 */

import { api } from '../api'
import type {
  VerifyEmailSuccessResponse,
  VerifyEmailErrorResponse,
  ResendEmailSuccessResponse,
  ResendEmailErrorResponse,
  EmailVerificationStatusResponse,
} from '../../types/email-verification'

/**
 * Verify email with token
 * @param token - 64-character hex verification token
 * @returns Success response or throws error
 */
export async function verifyEmail(
  token: string
): Promise<VerifyEmailSuccessResponse> {
  const response = await api.post<
    VerifyEmailSuccessResponse | VerifyEmailErrorResponse
  >('/email-verification/verify', { token })

  if ('error' in response) {
    throw response // Will be caught by TanStack Query
  }

  return response
}

/**
 * Resend verification email (requires authentication)
 * @returns Success response or throws error
 */
export async function resendVerificationEmail(): Promise<ResendEmailSuccessResponse> {
  const response = await api.post<
    ResendEmailSuccessResponse | ResendEmailErrorResponse
  >('/email-verification/send')

  if ('success' in response && !response.success) {
    throw response
  }

  return response
}

/**
 * Get email verification status (requires authentication)
 * @returns User's email and verification status
 */
export async function getEmailVerificationStatus(): Promise<EmailVerificationStatusResponse> {
  return api.get<EmailVerificationStatusResponse>(
    '/email-verification/status'
  )
}
